import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { Chip } from "@mui/material";
import { ScheduleOutlined } from "@mui/icons-material";

const formatTatTime = (seconds) => {
  const totalMinutes = Math.floor(seconds / 60);
  const secs = seconds % 60;

  if (totalMinutes >= 60) {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours}h ${minutes}m`;
  }

  return `${totalMinutes}m ${secs}s`;
};

dayjs.extend(duration);

export default function TatTimerChip({ row }) {

  const [now, setNow] = useState(dayjs());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(dayjs());
    }, 1000);

    return () => clearInterval(timer);
  }, []);


  const startTime =
    row?.interpretation_requested_at ||
    row?.interpretation_data?.requested_at;

  if (!startTime) return "--";

  let requestedAt;

  if (typeof startTime === "string" && startTime.includes(".")) {
    requestedAt = dayjs(startTime, "YYYYMMDDHHmmss.SSS");
  } else {
    requestedAt = dayjs(Number(startTime));
  }

  if (!requestedAt.isValid()) return "--";


  let slaMinutes =
    row?.sla_interpretation_minutes ??
    row?.business_tat_time ??
    row?.business?.interpretation_tat;

  slaMinutes = Number(slaMinutes);

  if (!slaMinutes || slaMinutes <= 0) {
    slaMinutes = 15;
  }

  const slaSeconds = slaMinutes * 60;


  if (
    row?.interpretation_request_status === "completed" &&
    row?.interpretation_completed_at
  ) {
    const completed = dayjs(Number(row.interpretation_completed_at));
    if (!completed.isValid()) return "--";

    const takenSeconds = completed.diff(requestedAt, "second");

    const isOverdue = takenSeconds > slaSeconds;

    return (
      <Chip
        icon={<ScheduleOutlined />}
        label={<strong>{formatTatTime(takenSeconds)}</strong>}
        color={isOverdue ? "error" : "success"}
        size="small"
      />
    );
  }


  const elapsed = now.diff(requestedAt, "second");
  const remaining = slaSeconds - elapsed;

  if (remaining <= 0) {
    return (
      <Chip
        icon={<ScheduleOutlined />}
        label={<strong>Overdue</strong>}
        color="error"
        size="small"
      />
    );
  }

  const warningThreshold = slaSeconds * 0.2;

  let chipColor = "success";

  if (remaining <= warningThreshold) {
    chipColor = "warning";
  }

  return (
    <Chip
      icon={<ScheduleOutlined />}
      label={<strong>{formatTatTime(remaining)}</strong>} color={chipColor}
      size="small"
    />
  );
}